<script lang="ts" module>
  import type { CheckoutSdk } from '@athena-lib/Checkout/utils';

  export type CustomStickersBundleProps = {
    formattedDiscount: string;
    units: number;
  };

  export const getCustomStickersBundleProps = (
    state: CheckoutSdk['state'],
    formatCurrency: (v: number) => string,
  ): CustomStickersBundleProps | undefined => {
    const lineItems = state.lines;

    if (!state.bundleSavings?.major) {
      return undefined;
    }

    const { units } = lineItems.reduce(
      (acc, line) => {
        if (line.price.bundleSavings && line.price.bundleSavings.major > 0) {
          return {
            units: acc.units + line.quantity,
          };
        }
        return acc;
      },
      {
        units: 0,
      },
    );

    return {
      formattedDiscount: formatCurrency(-state.bundleSavings?.major),
      units,
    };
  };
</script>

<script lang="ts">
  import { getCommonTranslations } from '@athena-lib/commonTranslationsContext';
  import { Text } from '@athena-lib/Text';

  const { formattedDiscount, units }: CustomStickersBundleProps = $props();
  const translations = getCommonTranslations();
  const bundleText = $derived(`${units} ${translations.stickers}`);

  // the desig was confusing, temporarily remove it
  const componentDisabled = true;
</script>

{#if !componentDisabled}
  <div class="flex items-center justify-between rounded-lg bg-st-white p-4">
    <div class="flex flex-col gap-1">
      <Text size="xsmall" class="uppercase">{translations.customStickersBundle}</Text>
      <Text size="small" bold>{bundleText}</Text>
    </div>
    <Text color="magenta" size="small" bold>{formattedDiscount}</Text>
  </div>
{/if}
